import BugReportIcon from '@mui/icons-material/BugReport';
import { Link, Typography } from '@mui/material';
import { useState } from 'react';
import BugReporting from '/@/components/help-center/bug-reporting';
import { _ } from '/@/locale';

export function HelpCenterReportProblemLink() {
    const [reportOpen, setReportOpen] = useState(false);
    return (
        <>
            <Link
                component='button'
                type='button'
                onClick={() => setReportOpen(true)}
                underline='always'
                sx={{
                    cursor: 'pointer',
                    color: (t) => t.palette.secondary.main,
                    textDecoration: 'underline',
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                <BugReportIcon sx={{ fontSize: 14 }} color='secondary' />
                <Typography variant='subtitle1' color='secondary'>
                    {_('Quiero reportar un problema')}
                </Typography>
            </Link>
            <BugReporting open={reportOpen} onClose={() => setReportOpen(false)} />
        </>
    );
}
